import { render, staticRenderFns } from "./PlayerDeviceTokenEdit.vue?vue&type=template&id=067ff854&scoped=true&"
import script from "./PlayerDeviceTokenEdit.vue?vue&type=script&lang=js&"
export * from "./PlayerDeviceTokenEdit.vue?vue&type=script&lang=js&"
import style0 from "./PlayerDeviceTokenEdit.vue?vue&type=style&index=0&id=067ff854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067ff854",
  null
  
)

export default component.exports